/**
 * Capitalize string
 */

export default function capitalize(str) {
  if (!str) return '';

  return str.replace(
    /\w\S*/g,
    txt => `${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`
  );
}
